import React from "react";

const About = () => {
  return (
    <div
      name="about"
      id="About"
      className="w-full h-100 bg-gradient-to-b from-gray-800 to-black text-white about"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            About
          </p>
        </div>

        <p className="text-xl mt-5">
        Hello my name is Chetan Sharma. I come from printing Hello World, to becoming a passionate Full Stack Web Developer. I always push myself to learn new things and work on them with interest.
        </p>
        <br />
        <p className="text-xl">
        My interest in web development started last year when I was trying to make my resume on the web by using HTML and CSS with the help of YouTube videos, which taught me a lot. <br /> <br />
        During this time, I came across Masai School and decided to join. After spending half a month at the institute, I became certain that I will pursue web development as my career.<br /> <br />
        I built a number of web applications and 3 major projects. Learned a great deal about teamwork, leadership, and communication. Here I am looking for an opportunity as a full-stack web developer.
        </p>
      </div>
    </div>
  );
};

export default About;
